import { Link } from 'react-router-dom';
import StanceBar from './StanceBar';
import { mockTopics } from '@/mocks/topics';

export type TopicItem = (typeof mockTopics)[number];

export function categoryName(id: string) {
  const map: Record<string, string> = {
    entertainment: '娱乐热点',
    society: '社会民生',
    internet: '互联网舆情',
    film: '影视综艺',
    sports: '体育赛场',
    tech: '科技前沿',
  };
  return map[id] ?? '综合热议';
}

function formatHeat(heat: number) {
  return heat >= 10000 ? `${(heat / 10000).toFixed(1)}万` : `${heat}`;
}

export default function TopicCard({ topic, rank }: { topic: TopicItem; rank?: number }) {
  return (
    <article
      className="group flex flex-col bg-background-50 border border-background-200/80 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
    >
      <Link to={`/topic/${topic.id}`} className="block cursor-pointer">
        <div className="relative w-full h-44 overflow-hidden">
          <img
            src={topic.cover}
            alt={`${topic.title} 相关讨论配图`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/90 backdrop-blur text-xs font-medium text-primary-700">
            {categoryName(topic.category)}
          </span>
          {typeof rank === 'number' && (
            <span className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-sm font-bold">
              {rank}
            </span>
          )}
        </div>
      </Link>
      <div className="flex flex-col flex-1 p-4 md:p-5">
        <Link to={`/topic/${topic.id}`} className="cursor-pointer">
          <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
            {topic.title}
          </h3>
        </Link>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{topic.summary}</p>

        <div className="mt-4">
          <StanceBar support={topic.stance.support} oppose={topic.stance.oppose} neutral={topic.stance.neutral} compact />
        </div>

        <div className="mt-4 pt-4 border-t border-background-200/70 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-fire-line text-primary-500"></i>
            热度 {formatHeat(topic.heat)}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-discuss-line"></i>
            {topic.participants.toLocaleString()} 人讨论
          </span>
        </div>
      </div>
    </article>
  );
}